module.exports = __webpack_public_path__ + "static/media/hero_mobile.5e2c47fb.webp";